<script>
import { ref, onMounted, computed } from 'vue';
import { useRouter } from 'vue-router';
import axios from 'axios';

export default {
  setup() {
    // Reactive state
    const gallery = ref(0);
    const selectedOption = ref('');
    const isButtonDisabled = ref(true);
    const selectedLabel = ref('');
    const isDropdownOpen = ref(false);
    const router = useRouter();

    // Computed property
    const buttonClass = computed(() => (selectedOption.value ? 'button-active' : 'button-disabled'));

    // Methods
    const callGalleryApi = () => {
      axios
        .get('/api/v1/gallery')
        .then((response) => {
          gallery.value = response.data.data;
          console.log(gallery.value)
        })
        .catch((error) => {
          console.error('Failed to fetch gallery data:', error);
        });
    };

    const updateButton = () => {
      isButtonDisabled.value = selectedOption.value === '';
    };

    const selectOption = (value, label) => {
      selectedOption.value = value;
      selectedLabel.value = label;
      isDropdownOpen.value = false;
      updateButton();
    };

    const handleButtonClick = () => {
      if (selectedOption.value) {
        window.location.href = selectedOption.value;
      } else {
        alert('Sila pilih kategori terlebih dahulu.');
      }
    };

    const navigateToGallery = () => {
      router.push({ name: 'Gallery Page' });
    };

    // Lifecycle hook
    onMounted(() => {
      callGalleryApi();
    });

    // Expose to template
    return {
      gallery,
      selectedOption,
      isButtonDisabled,
      selectedLabel,
      isDropdownOpen,
      buttonClass,
      updateButton,
      selectOption,
      handleButtonClick,
      navigateToGallery,
    };
  },
};
</script>

<template>
  <div class="landing">
    <div class="center-content">
      <!-- SECTION - HERO -->
      <main class="sectionhero">
        <nav class="header">
          <div class="frame-3">
            <router-link :to="{'name' : 'Welcome Page'}" class="header-logo"><img src="../assets/icons/WelcomePage/delimaflixlogo.svg" class="header-logo"/></router-link>
          </div>
          <div class="login-container">
            <div class="login-section">
              <div class="relative w-full">
                <!-- Dropdown button -->
                  <button
                    @click="isDropdownOpen = !isDropdownOpen"
                    class="btn-login w-full pr-10 text-left"
                  >
                    {{ selectedLabel || 'Pilih Kategori' }}
                  </button>

                  <!-- Fixed-position dropdown arrow -->
                  <img
                    src="../assets/icons/WelcomePage/icon-arrow-down.svg"
                    class="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
                  />

                  <!-- Dropdown options -->
                  <ul
                    v-show="isDropdownOpen"
                    class="absolute z-10 left-0 w-full mt-2 bg-[#4e2f21] border border-[#fff3] rounded-md text-white shadow-lg"
                  >
                    <li
                      class="px-4 py-2 hover:bg-[#ffffff22] cursor-pointer"
                      @click="selectOption('https://delimaflix.moe.gov.my/dashboard', 'Murid')"
                    >
                      Murid
                    </li>
                    <li
                      class="px-4 py-2 hover:bg-[#ffffff22] cursor-pointer"
                      @click="selectOption('https://app-delima.moe.gov.my/mps/login', 'Guru')"
                    >
                      Guru
                    </li>
                    <li
                      class="px-4 py-2 hover:bg-[#ffffff22] cursor-pointer"
                      @click="selectOption('https://delimaflix.moe.gov.my/dashboard', 'KPM/JPN/PPD')"
                    >
                      KPM/JPN/PPD
                    </li>
                  </ul>
                </div>
              </div>

            <div class="login-section">
              <button
                id="loginButton"
                :disabled="!selectedOption"
                :class="buttonClass"
                @click="handleButtonClick"
              >
                <div class="text-wrapper-3 desktop-only">Log Masuk</div>
                <img src="../assets/icons/WelcomePage/icon-login.svg" class="login-icon mobile-only"/>
              </button>
            </div>
          </div>
        </nav>

        <div class="frame">
          <div class="frame-2">
            <h1 class="delimaflix"><span class="text-wrapper">DELIMaFLiX</span></h1>
            <h2 class="ajar-belajar-di-mana">Belajar lebih seronok, di mana-mana sahaja!</h2>
            <p class="hero-text">
              DELIMaFLiX ialah hab repositori pintar yang menghimpun pelbagai bahan pembelajaran digital seperti video DidikTV, video interaktif,
               permainan digital, Podcast, komik digital, buku teks dan banyak lagi. Kesemuanya berada dalam satu platform yang selamat, mudah dan
               menyeronokkan. Kini anda boleh strim, main dan ulang kaji di mana-mana sahaja pada bila-bila masa.
            </p>
          </div>
          <!-- <div>
            <a class="btn-blue-l" target="_blank" href="https://delimaflix.moe.gov.my/dashboard">
              <div class="div-2"><div class="text-wrapper-2">Mula Belajar</div></div>
            </a>
          </div> -->
          <div class="frame">
            <img class="desktop-pelajar" src="../assets/Images/Views/WelcomePage/Hero-img.png" />
          </div>
        </div>
      </main>
      <!-- SECTION - HERO - END -->


      <!-- SECTION 1 - FAEDAH MENGGUNAKAN EDUVAULT -->
<div class="mx-auto max-w-2xl px-4 sm:px-6 lg:max-w-7xl lg:px-8 pt-16">
  <p class="mx-auto mt-2 max-w-lg text-center text-2xl sm:text-4xl md:text-5xl font-semibold tracking-tight text-gray-950">
    Faedah DELIMaFLiX
  </p>

  <div class="mt-10 grid gap-6 sm:mt-16 lg:grid-cols-3 lg:grid-rows-2">
    <!-- Faedah 1 -->
    <div class="relative lg:row-span-2">
      <div class="absolute inset-px rounded-lg bg-white lg:rounded-l-3xl"></div>
      <div class="relative flex h-full flex-col overflow-hidden rounded-xl lg:rounded-l-[calc(1.5rem+1px)]">
        <div class="px-6 pt-6 pb-3 sm:px-10 sm:pb-0">
          <p class="text-lg sm:text-xl md:text-2xl font-semibold text-gray-950 text-center">Semua dalam satu platform</p>
          <p class="mt-4 mb-4 text-sm sm:text-base md:text-lg text-gray-600 text-center max-w-lg">
            Akses buku teks digital, video pembelajaran, Podcast pendidikan, bahan interaktif dan banyak lagi tanpa perlu menukar platform.
          </p>
        </div>
        <div class="relative min-h-[20rem] sm:min-h-[24rem] lg:min-h-[30rem] w-full grow mx-auto max-w-md">
          <div class="flex items-center justify-center h-auto w-auto p-6">
            <img class="w-full max-w-xs mx-auto" src="../assets/icons/WelcomePage/faedah1.png" alt="Faedah 1">
          </div>
        </div>
      </div>
      <div class="pointer-events-none absolute inset-px rounded-lg shadow-lg ring-1 ring-black/5 lg:rounded-l-3xl"></div>
    </div>

    <!-- Faedah 2 -->
    <div class="relative">
      <div class="absolute inset-px rounded-lg bg-white lg:rounded-tr-3xl"></div>
      <div class="relative flex flex-col overflow-hidden rounded-xl">
        <div class="px-4 pt-4 sm:px-4">
          <p class="text-lg sm:text-xl md:text-2xl font-semibold text-gray-950 text-center">Gunakan DELIMa ID</p>
          <p class="mt-2 text-sm sm:text-base md:text-lg text-gray-600 text-center max-w-lg mx-auto">
            Gunakan DELIMa ID anda untuk mula belajar serta-merta. Tiada muat turun, tiada gangguan.
          </p>
        </div>
        <div class="flex flex-1 items-center justify-center px-4 pt-4 pb-6 sm:px-6 lg:pb-2">
          <img class="w-full max-w-xs mx-auto" src="../assets/icons/WelcomePage/faedah2.png" alt="Faedah 2">
        </div>
      </div>
      <div class="pointer-events-none absolute inset-px rounded-lg shadow-lg ring-1 ring-black/5 lg:rounded-tr-3xl"></div>
    </div>

    <!-- Faedah 3 -->
    <div class="relative lg:col-start-2 lg:row-start-2">
      <div class="absolute inset-px rounded-lg bg-white"></div>
      <div class="relative flex flex-col overflow-hidden rounded-xl">
        <div class="px-4 pt-4 sm:px-4">
          <p class="text-lg sm:text-xl md:text-2xl font-semibold text-gray-950 text-center">Playlist</p>
          <p class="mt-2 text-sm sm:text-base md:text-lg text-gray-600 text-center max-w-lg mx-auto">
            Guru boleh mencipta, menyusun dan menyebar senarai main khas kepada murid melalui Playlist. Murid boleh akses Playlist guru dengan mudah untuk belajar.
          </p>
        </div>
        <div class="flex flex-1 items-center justify-center px-4 pt-4 pb-6 sm:px-6 lg:pb-2">
          <img class="w-full max-w-xs mx-auto" src="../assets/icons/WelcomePage/faedah3.png" alt="Faedah 3">
        </div>
      </div>
      <div class="pointer-events-none absolute inset-px rounded-lg shadow-lg ring-1 ring-black/5"></div>
    </div>

    <!-- Faedah 4 -->
    <div class="relative lg:row-span-2">
      <div class="absolute inset-px rounded-lg bg-white lg:rounded-r-3xl"></div>
      <div class="relative flex flex-col overflow-hidden rounded-xl lg:rounded-r-[calc(1.5rem+1px)]">
        <div class="px-6 pt-6 pb-3 sm:px-10 sm:pb-0">
          <p class="text-lg sm:text-xl md:text-2xl font-semibold text-gray-950 text-center">Selamat & Bebas Gangguan</p>
          <p class="mt-4 mb-4 text-sm sm:text-base md:text-lg text-gray-600 text-center max-w-lg">
            Tiada iklan, tiada unsur luar, hanya kandungan. DELIMaFLiX memastikan murid belajar dalam persekitaran terkawal, fokus dan selamat.
          </p>
        </div>
        <div class="relative min-h-[20rem] sm:min-h-[24rem] lg:min-h-[30rem] w-full grow mx-auto max-w-md">
          <div class="flex items-center justify-center h-auto w-auto p-6">
            <img class="w-full max-w-xs mx-auto" src="../assets/icons/WelcomePage/faedah4.png" alt="Test">
          </div>
        </div>
      </div>
      <div class="pointer-events-none absolute inset-px rounded-lg shadow-lg ring-1 ring-black/5 lg:rounded-r-3xl"></div>
    </div>
  </div>
</div>
<!-- SECTION 1 - END -->




      <!-- SECTION 2 - TENTANG DELIMA FLIX -->
      <div id="section-tentang-EDUVAULT" class="tentang-EDUVAULT">
        <h2><span class="text-wrapper-7">Tentang DELIMaFLiX</span></h2>
      </div>
      <div class="section2">
        <!-- section 2.1 -->
        <div class="group-19">
          <div class="group-20">
            <div class="overlap-7">
              <img class="rectangle-2" src="../assets/Images/Views/WelcomePage/urus-modal-pelajaran-1.png" />
            </div>
          </div>
          <div class="group-20">
            <div class="frame-20">
              <div class="text-wrapper-29">Selamat, berkualiti dan berfokus.</div>
              <p class="text-wrapper-30">
                Sumber Pintar Kepada Pelbagai Bahan Digital
              </p>
              <div class="frame-21">
                <div class="details">
                  <div class="done">
                    <div class="path-wrapper">
                      <img src="../assets/icons/WelcomePage/tick-icon.svg" />
                    </div>
                  </div>
                  <p class="text-wrapper-31">
                    Repositori pintar untuk guru dan murid mengakses video, Podcast, media interaktif dan dokumen tanpa perlu muat turun
                    bahan atau pemasangan perisian tambahan.
                  </p>
                </div>
                <div class="details">
                  <div class="done">
                    <div class="path-wrapper">
                      <img src="../assets/icons/WelcomePage/tick-icon.svg" />
                    </div>
                  </div>
                  <p class="text-wrapper-31">
                    Kesemua bahan pembelajaran digital kini boleh diakses melalui satu platform tanpa gangguan, tanpa kerumitan.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- section 2.2 -->
        <div class="group-34">
          <div class="frame-25">
            <div class="frame-20">
              <div class="text-wrapper-29">Apakah keistimewaan DELIMaFLiX?</div>
              <!--<p class="text-wrapper-30">Kandungan Rasmi & Berkualiti</p>-->
              <div class="frame-21">
                <p class="text-wrapper-30">Kandungan Rasmi & Berkualiti</p>
                <div class="details">
                  <div class="done">
                    <div class="overlap-group-9">
                      <img src="../assets/icons/WelcomePage/tick-icon.svg" />
                    </div>
                  </div>
                  <p class="text-wrapper-31">Menyediakan akses kepada bahan pembelajaran digital yang disahkan oleh KPM seperti video, media interaktif, podcast dan dokumen sokongan.</p>
                </div>
                <p class="text-wrapper-30">Kawalan & Susun Atur oleh Guru</p>
                <div class="details">
                  <div class="done">
                    <div class="overlap-group-9">
                      <img src="../assets/icons/WelcomePage/tick-icon.svg" />
                    </div>
                  </div>
                  <p class="text-wrapper-31">Guru boleh membina dan mengatur senarai main kandungan mengikut tahap, kelas atau topik pembelajaran yang sesuai.</p>
                </div>
                <p class="text-wrapper-30">Mudah Dicapai & Teratur</p>
                <div class="details">
                  <div class="done">
                    <div class="overlap-group-9">
                      <img src="../assets/icons/WelcomePage/tick-icon.svg" />
                    </div>
                  </div>
                  <p class="text-wrapper-31">
                    Semua bahan disusun mengikut kategori dan format untuk memudahkan pencarian dan penggunaan.</p>
                </div>
                <p class="text-wrapper-30">Selamat & Terkawal</p>
                <div class="details">
                  <div class="done">
                    <div class="overlap-group-9">
                      <img src="../assets/icons/WelcomePage/tick-icon.svg" />
                    </div>
                  </div>
                  <p class="text-wrapper-31">
                    Kandungan yang dipaparkan merupakan koleksi terpilih bagi memastikan pengalaman pembelajaran digital yang selamat dan berfokus kepada kurikulum.                  </p>
                </div>
              </div>
            </div>

          </div>
          <div class="group-35">
            <div class="overlap-13">
              <img class="rectangle-21" src="../assets/Images/Views/WelcomePage/mudah-digunakan-2.png" />
            </div>
          </div>
        </div>

        <!-- section 2.3 -->
        <div class="group-22">
          <div class="group-20">
            <div class="overlap-9">
              <img class="rectangle-3" src="../assets/Images/Views/WelcomePage/perkayakan-ilmu-pengetahuan-3.png" />
            </div>
          </div>
          <div class="frame-22">
            <div class="frame-20">
              <div class="text-wrapper-29">Tingkatkan Pengalaman Pembelajaran</div>
              <div class="text-wrapper-30">Kandungan Berstruktur & Mudah Dicari</div>
              <div class="frame-21">
                <div class="details">
                  <div class="done">
                    <div class="img-wrapper">
                      <img class="path" src="../assets/icons/WelcomePage/tick-icon.svg" />
                    </div>
                  </div>
                  <p class="text-wrapper-31">
                    Kandungan dipaparkan mengikut kategori, tahap atau subjek untuk memudahkan murid membuat carian bahan pembelajaran serta
                    menyokong pembelajaran yang diperibadikan.                  </p>
                </div>
                <div class="text-wrapper-30">Senarai Main Peribadi</div>
                <div class="details">
                  <div class="done">
                    <div class="img-wrapper">
                      <img class="path" src="../assets/icons/WelcomePage/tick-icon.svg" />
                    </div>
                  </div>
                  <p class="text-wrapper-31">
                    Murid boleh simpan, susun dan ulang main bahan kegemaran mereka dalam Playlist.
                  </p>
                </div>
                <div class="text-wrapper-30">Kebolehcapaian & Bahasa</div>
                <div class="details">
                  <div class="done">
                    <div class="img-wrapper">
                      <img class="path" src="../assets/icons/WelcomePage/tick-icon.svg" />
                    </div>
                  </div>
                  <p class="text-wrapper-31">
                    Repositori pintar yang menyokong pelbagai bahasa dan ciri mesra pengguna untuk memastikan kesemua murid mendapat pengalaman
                    pembelajaran yang sama rata.
                  </p>
                  </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <!-- SECTION 2 - END -->

       <!-- SECTION - GALLERY DELIMAFLIX -->
        <!-- <div id="section-tentang-EDUVAULT" class="tentang-EDUVAULT">
          <h2><span class="text-wrapper-7">Galeri DELIMaFLiX</span></h2>
        </div>
        <div class="gallery">
          <div v-for="item in gallery" :key="item.id" class="gallery-item">
            <img :src="item.image_url" :alt="item.alt_text || 'Gallery Image'">
            <div class="overlay">
              <h3>{{ item.title }}</h3>
              <p>{{ item.description }}</p>
            </div>
          </div>
        </div>

        <div class="gallery-see-more">
          <button @click="navigateToGallery" class="btn-see-more">
            <span>Lihat Semua</span>
            <img src="../assets/icons/WelcomePage/icon-arrow-down.svg" class="arrow-icon" alt="Arrow" />
          </button>
        </div> -->
      <!-- SECTION - GALLERY DELIMAFLIX  -->

      <!-- SECTION 3 - GUNAKAN DELIMAFLIX -->
      <div class="terokai">
        <div class="terokai-left">
          <img class="terokai-img" src="../assets/Images/Views/WelcomePage/terokai-img.png" />
        </div>
        <div class="terokai-right">
          <div class="text-wrapper-29">Inisiatif Kementerian Pendidikan</div>
          <p class="text-wrapper-terokai">
            <br>DELIMaFLiX ialah sebahagian daripada inisiatif Dasar Pendidikan Digital untuk memperkasakan pendidikan masa hadapan -
            selamat, menyeronokkan dan mudah diakses oleh semua murid di seluruh negara.</p>
          <br>
        </div>
      </div>
      <!-- SECTION 3 - END -->

      <!-- SECTION 4 - LOGO -->
      <div class="flex flex-wrap justify-center items-center gap-8 gap-y-4 py-10 bg-white text-center" style="margin-bottom: 150px;">
        <img src="../assets/Images/Views/WelcomePage/kpmlogo.png" class="h-24 sm:h-28 md:h-32 lg:h-36 w-auto" />
        <img src="../assets/Images/Views/WelcomePage/madanilogo.png" class="h-24 sm:h-28 md:h-32 lg:h-36 w-auto" />
      </div>
      <!-- SECTION 4 - END -->


      <!-- SECTION FOOTER -->
      <div class="overlap-2">
        <div class="overlap-3">
          <div class="frame-10">
            <div class="frame-11">
              <div class="frame-3">
                <img src="../assets/icons/WelcomePage/delimaflixlogo.svg" class="header-logo"/>
              </div>
              <div class="menggabungkan-tempat">Menggabungkan tempat <br />pengajaran dan pembelajaran.</div>
              <div class="footer-list">
                <div>
                  <ul>
                    <li class="text-wrapper-17"><router-link :to="{'name' : 'Privacy Page'}" class="text-gray-500">Privasi & Polisi</router-link></li>
                    <li class="text-wrapper-17"><router-link :to="{'name' : 'Term Page'}" class="text-gray-500">Terma & Syarat</router-link></li>
                  </ul>
                </div>
              </div>
            </div>

          </div>

          <div class="frame-10">
            <img class="phone-cikgu" src="../assets/Images/Views/WelcomePage/desktop-mobile-footer.png" />
          </div>
        </div>
      </div>
      <!-- SECTION FOOTER - END -->
    </div>
  </div>
</template>
